import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  NoInternetHeading: {
    id: 'app.signup.toast.no-int-heading',
    description: 'No internet heading for toast',
    defaultMessage: 'No internet',
  },
  NoInternetBody: {
    id: 'app.signup.toast.no-int-body',
    description: 'No internet body for toast',
    defaultMessage: 'Check your network connectivity and try again',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/toast/i18n.js